<template>
  <div class="sms d-flex">
    <Right :chat="chat"></Right>
  </div>
</template>

<script>
import Right from "../components/sms/Right.vue";
export default {
  components: { Right },
  data() {
    return {
      chat: {}
    };
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    init() {
      const { id } = this.$route.params;
      const { name, phone } = this.$route.query;
      this.chat = { id, name, phone };
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.sms {
  display: flex;
}
</style>
